import { OPTIONS } from "../../../utils/core";
import MyPopup from "../MyPopup";
import Icon from "../Icon";

/**
 * Props:
 * - value: "small" | "normal" | "large" | "huge"
 * - onChange: (newValue) => void
 */

interface FontSizePickerProps {
  value?: number;
  onChange?: (value: string) => void;
}

export default function FontSizePicker({
  value = 16,
  onChange = () => {},
}: FontSizePickerProps) {
  return (
    <div>
      <MyPopup
        trigger={
          <button
            className="font-option heading tool-bar-button"
            data-tooltip="Size"
          >
            <Icon name="TextFields" className="tool-bar-button-icon" />
            <Icon name="DownArrow" className="tool-bar-button-icon" />
          </button>
        }
      >
        {({ close }) => (
          <div className="p-4 mail-inbox-popup-content">
            <div className="font-options">
              {OPTIONS.map((font) => (
                <button
                  className="btn-mail-editor"
                  key={font.key}
                  onClick={() => {
                    onChange(font.key);
                    close();
                  }}
                  style={{ fontSize: `${font.sizePx}px` }}
                >
                  <div className="font-option">
                    {value === font.sizePx && <Icon name="Check" />}
                    {font.label}
                  </div>
                </button>
              ))}
            </div>
          </div>
        )}
      </MyPopup>
    </div>
  );
}
